module.exports = __webpack_public_path__ + "media/components/journeys/ticket-icons/emergency-70d7e8a2d11512e4bf80da5b57a2a41e.png";